import {
  changeUserPassword,
  getUserDetail,
  updateUserProfileDetails,
  updateUserProfilePic,
} from "../../../helpers/backend_helper";

import {
  getuserDetails,
  errorMessages,
  hideErrorMessage,
  setLoading
} from "./reducer";

export const getUserDetails = () => async (dispatch) => {
  try {
    setLoading({ type: "read", value: true });
    const response = await getUserDetail();
    dispatch(getuserDetails(response));
    return true;
  } catch (error) {
    // console.log("error", error.response.data.errors);

    // dispatch(errorMessages(error.response.data.errors));
    return false;
  } finally {
    setLoading({ type: "read", value: false });
  }
};

export const updateProfilePic = (value) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "profilePicUpdate", value: true }));
    const response = await updateUserProfilePic(value);
    return { success: true, message: "Profile Picture Successfully Updated" };
  } catch (error) {
    console.log("error", error.response.data.errors);
    dispatch(errorMessages(error.response.data.errors));
    return { success: false, message: error.response.data.errors };
  } finally {
    dispatch(setLoading({ type: "profilePicUpdate", value: false }));
  }
};

export const updateProfileDetails = (value) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "update", value: true }));
    const response = await updateUserProfileDetails(value);
    return { success: true, message: "Profile Successfully Updated" };
  } catch (error) {
    console.log("error", error.response.data.errors);
    dispatch(errorMessages(error.response.data.errors));
    return { success: false, message: error.response.data.errors };
  } finally {
    dispatch(setLoading({ type: "update", value: false }));
  }
};

export const changePassword = (value) => async (dispatch) => {
  try {
    dispatch(setLoading({ type: "passwordChange", value: true }));
    const response = await changeUserPassword(value);
    return { success: true, message: "Password Successfully Updated, Please Login Again" };
  } catch (error) {
    console.log("error", error.response.data.errors);
    dispatch(errorMessages(error.response.data.errors));
    return { success: false, message: error.response.data.errors };
  } finally {
    dispatch(setLoading({ type: "passwordChange", value: false }));
  }
};
